import React from 'react';
import * as S from './Styled';

const Icon = ({
  name,
  title,
  active,
  style,
  className,
  size,
  iconAttr,
  ...props
}) => {
  const Svg = (
    <S.Icon
      name={name}
      active={active}
      style={style}
      size={size}
      classes={className}
      {...iconAttr}
      {...props}
    >
      <use xlinkHref={'/spritemap.svg#icon-' + name} />
    </S.Icon>
  );

  if (title) {
    return (
      <S.Helper>
        {Svg}
        <S.Title>
          <S.Inner>{title}</S.Inner>
        </S.Title>
      </S.Helper>
    );
  }

  return Svg;
};

export default Icon;
